import { requestGet } from '@/common/request';

export interface searchParams {
  keyword: string;
}

export interface searchRes {
  _systemTime: number;
  code: string;
  data: any;
  isSuccess: boolean;
  message: string;
  success: boolean;
  systemTime: string;
  ret: string;
  msg: string;
}

//全局搜索-活动信息-运营端
export async function search(params: searchParams): Promise<searchRes> {
  return await requestGet('/generic/mac/yx/activity/global/search', params);
}
